import React from "react";
import { Row } from "reactstrap";
import lock from "../../assets/img/lock.svg";

const PaymentSecurityInfo = ({ darkMode }) => (
  <Row>
    <div className="d-flex justify-content-center align-items-start mx-2 mt-5">
      <img
        alt="lock"
        src={lock}
        className={darkMode ? "lock-bg mx-3" : "mx-3"}
      />
      <h6 className="fs--16 fw--400 mb-0 text-muted">
        We protect your payment information using encryption to provide
        bank-level security.
      </h6>
    </div>
  </Row>
);

export default PaymentSecurityInfo;
